import { Navigate, Outlet } from "react-router-dom";
import { getAdminAccessToken, getAdminUserInfo } from "@lib/storeManager";
import { paths } from "../utils/paths";

const AdminProtectedRouter = () => {
  const token = getAdminAccessToken();
  const userInfo = getAdminUserInfo();

  // For the admin portal, we strictly check for admin user type
  // and presence of token
  const isAdmin = token && userInfo?.user_type === "admin";

  if (!isAdmin) {
    // Redirect to the admin login page (paths.login = / when at root, /jainelibrary-admin when tenant in URL)
    return <Navigate to={paths.login} replace />;
  }

  return <Outlet />;
};

export default AdminProtectedRouter;
